const STORAGE_KEY = 'pica_metric'

class Storage {
    constructor() {
        this.messages = []
        this.sending = []
        const jsonMsg = localStorage.getItem(STORAGE_KEY)
        if (jsonMsg === null) this.messages = []
        else this.messages = JSON.parse(jsonMsg)
    }

    add(message) {
        this.messages.push(message)
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.messages))
    }

    get() {
        const toSend = this.messages.filter(msg => !this.sending.includes(msg))
        this.sending = this.sending.concat(toSend)
        return toSend
    }

    sent(messages) {
        this.messages = this.messages.filter(msg => !messages.includes(msg))
        this.sending = this.sending.filter(msg => !messages.includes(msg))
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.messages))
    }

    failed(messages) {
        this.sending = this.sending.filter(msg => !messages.includes(msg))
    }
}

export default new Storage()